import React from 'react';
import { Pie } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

export function BudgetVisualizationModal({ isOpen, onClose, option }) {
  if (!isOpen) return null;

  // Filter out partners with 0 budget
  const partnersWithBudget = option.recommendations.filter(rec => rec.budget > 0);

  const data = {
    labels: partnersWithBudget.map(rec => rec.partner.name),
    datasets: [
      {
        data: partnersWithBudget.map(rec => rec.budget),
        backgroundColor: [
          '#FF6384',
          '#36A2EB',
          '#FFCE56',
          '#4BC0C0',
          '#9966FF'
        ],
        borderWidth: 1
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        labels: {
          font: {
            size: 12
          },
          padding: 10
        }
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const value = context.raw;
            const total = context.dataset.data.reduce((a, b) => a + b, 0);
            const percentage = ((value / total) * 100).toFixed(1);
            return `$${value.toLocaleString()} (${percentage}%)`;
          }
        }
      }
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content visualization-modal">
        <h2>Budget Distribution - Option {option.id}</h2>
        <div className="chart-container">
          <Pie data={data} options={options} />
        </div>
        <div className="budget-summary">
          <div className="total-budget">
            <span>Total Budget:</span>
            <span>${option.totalBudget.toLocaleString()}</span>
          </div>
        </div>
        <div className="modal-actions">
          <button className="button-secondary" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
} 